import React from 'react';
import { Image } from '../Image';
import { ImageGroupProps } from './ImageGroup.types';

export const ImageGroup = ({ images }: ImageGroupProps): JSX.Element => {
  if (!images || images?.length == 0) {
    return null;
  }

  return (
    <div className='image-group'>
      {images.map((img, index) => {
        return (
          <Image key={index} {...img} figureClassNames='image-group__media' />
        );
      })}
    </div>
  );
};

export default ImageGroup;
